import axios from "axios";

export class Caixas {
    static proximas (distance, lat, long) {
        return axios.get("/caixas-proximas/" + distance + "/" + lat + "/" + long);
    }

    static problemasSinal () {
        return axios.get("/problema/sinal");
    }

    static offline () {
        return axios.get("/caixas/offline");
    }

    static unregistered () {
        return axios.get("/onu-unregistered");
    }

    static caixaPacPon (id) {
        return axios.get("/caixas-pon/" + id);
    }

    static caixaCto (id) {
        return axios.get("/caixas-cto/" + id);
    }

    static allCtosByPon (slot, numero) {
        return axios.get("/all-ctos-by-pon/" + slot + "/" + numero);
    }

    static addPacPon (json) {
        return axios.post("/add-pacpon", json);
    }

    static ctos () {
        return axios.get("/ctos");
    }

    static clientes (id) {
        return axios.get("/clientes-na-caixa/" + id);
    }

    static clientesFtth (id) {
        return axios.get("/ftth-cto/" + id);
    }

    static clientesFtthUpdate (id) {
        return axios.get("/ftth-cto/" + id + "/update");
    }

    static caixasByPon (slot, numero) {
        return axios.get("/caixas-by-pon/" + slot + "/" + numero);
    }

    static pacponByCto (id) {
        return axios.get("/caixa-pacpon/by-cto/" + id);
    }

    static allCaixasByPon (slot, numero) {
        return axios.get("/all-caixas-by-pon/" + slot + "/" + numero);
    }

    static caixasByPonSemOnuID () {
        return axios.get("/caixa-pacpon/sem-onuid");
    }

    static registrar (json) {
        return axios.post("/onu-registrar", json);
    }
}
